import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store";
import reportWebVitals from "./reportWebVitals";

import { BrowserRouter } from "react-router-dom";
import setupInterceptors from "./core/service/setupInterceptors";

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/member">
    {/* <BrowserRouter> */}
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

setupInterceptors(store);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
